import React from 'react';
import { connect } from 'react-redux';

import { useIntl } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/ui.duck';

import { LayoutSingleColumn, Page } from '../../components';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import EditorialCard from '../LandingPage/sections/SectionEditorial/EditorialCard/EditorialCard';
import { editorials } from '../../config/editorials';

import marketingCss from '../_marketingPage/marketingPage.module.css';
import css from './MagasinPage.module.css';

/**
 * Magasin index page (`/magasin`).
 *
 * Lists every editorial article in `src/config/editorials.js` as a card.
 * Uses the shared `marketingPage.module.css` chrome (hero + capped
 * content) so it matches Contact / FAQ / Terms visually; the grid below
 * the hero is the one custom bit.
 *
 * @param {Object} props
 * @param {boolean} props.scrollingDisabled
 * @returns {JSX.Element}
 */
const MagasinPageComponent = props => {
  const intl = useIntl();
  const { scrollingDisabled } = props;

  return (
    <Page
      title={intl.formatMessage({ id: 'MagasinPage.metaTitle' })}
      description={intl.formatMessage({ id: 'MagasinPage.metaDescription' })}
      scrollingDisabled={scrollingDisabled}
    >
      <LayoutSingleColumn topbar={<TopbarContainer currentPage="MagasinPage" />} footer={<FooterContainer />}>
        <article className={marketingCss.root}>
          <div className={marketingCss.content}>
            <header className={marketingCss.hero}>
              <p className={marketingCss.heroEyebrow}>
                {intl.formatMessage({ id: 'MagasinPage.heroEyebrow' })}
              </p>
              <h1 className={marketingCss.heroHeading}>
                {intl.formatMessage({ id: 'MagasinPage.heroHeading' })}
              </h1>
              <p className={marketingCss.lede}>
                {intl.formatMessage({ id: 'MagasinPage.heroLede' })}
              </p>
            </header>

            <div className={css.grid}>
              {editorials.map(editorial => (
                <EditorialCard key={editorial.slug} editorial={editorial} />
              ))}
            </div>
          </div>
        </article>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => ({
  scrollingDisabled: isScrollingDisabled(state),
});

const MagasinPage = connect(mapStateToProps)(MagasinPageComponent);

export { MagasinPageComponent };
export default MagasinPage;
